import React from 'react';
import MyMap from '../components/MyMap';
import './home.css';
import '../App.css';
import BfwLogo from '../assets/turm.jpg';

function Home() {
  return (
    <div className="home-container">
      <div className="home-header ">
        <h1 >WALDÖKODATEN</h1>
        
      </div>

      
      <div className="home-map">
        <MyMap />
      </div>


      <section class="waldoekodaten-intro">
  <h2>Das Datenportal „Waldökodaten“ des BFW</h2>

  <p>
    Das Bundesforschungszentrum für Wald (BFW) stellt über das Portal „Waldökodaten“ 
    täglich aktualisierte, ökologisch relevante Rohdaten kostenlos zur Verfügung. 
    Diese stammen aus Forschungs- und Monitoringaktivitäten des BFW oder wurden von 
    der Stadt Wien bereitgestellt.
  </p>

  <div class="text-image-block">
    <div class="text-column">
      <h3>Datenbereiche</h3>
      <ul>
        <li>Wetterdaten von waldnahen Stationen</li>
        <li>Bodenfeuchte und Bodentemperatur</li>
        <li>Änderung des Stammumfangs</li>
      </ul>
      <br></br>
      <h3>Darstellung und Nutzung</h3>
      <ul>
        <li>Die Daten sind für die letzten 30 Tage verfügbar, die Daten der Stammumfänge dagegen bis zu einem Jahr.</li>
        <li>Diagramme können angezeigt und heruntergeladen werden.</li>
        <li>Zahlenwerte sind als CSV-Datei oder tabellarisch als PDF-Datei downloadbar.</li>
        <li>Details zur Nutzung der Daten sind im Impressum im Abschnitt „Copyright“ zu finden.</li>
      </ul>
    </div>
    <div class="image-column">
      <img src={BfwLogo} alt="bfw-logo" className="llogo" />
    </div>
  </div>
</section>

    </div>
  );
}

export default Home;
